import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import store from "./store";
import router from "./router";
import Notifications from "vue-notification";
import { formatDate, role, truncate } from "@/filters";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import "./validation";

import DeepPath from "./plugins/deeppath";
Vue.use(DeepPath);

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
import "vue-swatches/dist/vue-swatches.css";
import "@/assets/global.scss";
import "@/assets/ol.scss";
import "@/assets/ol-ext.css";
import VueHotkey from "v-hotkey";

import {
  INIT_KEYCLOAK,
  MODULE_AUTHENTICATION
} from "@/store/modules/authentication";

import i18n from "./i18n";

Vue.use(VueHotkey);

Vue.config.productionTip = false;
Vue.use(Notifications);

Vue.filter("formatDate", formatDate);
Vue.filter("truncate", truncate);
Vue.filter("role", role);

let initializeVue = function() {
  new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
  }).$mount("#app");
};

let initialize = async function() {
  try {
    await store.dispatch(MODULE_AUTHENTICATION + INIT_KEYCLOAK);
    initializeVue();
  } catch (e) {
    console.error(e);
  }
};

initialize();
